const Button = ({
    variant = "primary",
    className = "",
    type = "button",
    children,
    ...props
}) => {
    const variantClass = variant === "secondary" ? "btn-secondary" : "btn-primary";

    return (
        <button
            type={type}
            className={`${variantClass}${className ? ` ${className}` : ""}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
